import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import './App.scss'; // Import your main styles
import PrototypeNewApp from "./components/Prototypes/PrototypeNew/App";

function App() {
    return (
        <Router>
            <div>
                <PrototypeNewApp />
            </div>
        </Router>
    );
}

export default App;
